import { Pipe, PipeTransform } from '@angular/core';
import { PageConfig } from '../entities';
import { CurafidaFeatureEnum } from '../entities/base-page-config';
import { FeatureConfigs } from '../../common/entities/curafida-frontend-configuration';
import { ConfigurationDetail, ConfigurationDetailFeatures } from '../resources/configuration.resource';

@Pipe({
    name: 'checkFeaturePipe',
})
export class CheckFeaturesPipe implements PipeTransform {
    transform(
        menuItems: PageConfig[],
        featuresConfiguration: FeatureConfigs,
        configurationFromBackend: ConfigurationDetail,
    ) {
        if (!menuItems) {
            return menuItems;
        }

        return menuItems.filter((menuItem) => {
            const hasSubPage = menuItem.childPageConfigs?.length > 0;
            if (hasSubPage) {
                return menuItem.role.length === 0;
            } else {
                const menuItemModule = menuItem?.module as keyof ConfigurationDetailFeatures;
                if (configurationFromBackend?.features[menuItemModule]) {
                    return !!configurationFromBackend?.features[menuItemModule]?.enabled;
                }
                const featureKey = menuItem?.module as keyof FeatureConfigs;
                if (
                    featuresConfiguration[featureKey]?.enabled ||
                    featuresConfiguration[featureKey]?.enabled === undefined ||
                    menuItem.module === CurafidaFeatureEnum.common
                ) {
                    return menuItem.role.length === 0;
                }
            }
        });
    }
}
